import Vue from 'vue'
import VueRouter from 'vue-router'

import { find, forOwn, map, compact } from 'lodash'
import LocationMap from '@/views/LocationMap.vue'
import LocationMapPolygonDraw from '@/views/LocationMapPolygonDraw'
import MultiLocationMap from '@/views/MultiLocationMap.vue'
import SustainabilityDataEntry from '@/views/SustainabilityDataEntry.vue'
import LabelService from '@/services/LabelService'
import MainMenuService from '@/services/MainMenuService'
import ChartConfigurations from '@/components/list-view-visualisation/chart/ChartConfigurations'
import i18nlookup from './views/i18nlookup'
import i18nForm from './views/i18nForm'
import BulkUpdate from './views/BulkUpdate'
import ListViewVisualisation from './views/ListViewVisualisation'
import StateDesigner from './views/StateDesigner'
import WalkthroughDesigner from './views/WalkthroughDesigner'
import ViewConfiguration from './views/ViewConfiguration'
import ImportsStatus from './views/ImportsStatus'
import E360Container from './views/E360Container'

Vue.use(VueRouter)

const routes = [
  {
    path: ViewConfiguration.stateDesigner.path,
    name: ViewConfiguration.stateDesigner.name,
    component: StateDesigner,
  },
  {
    path: ViewConfiguration.i18nLookup.path,
    name: ViewConfiguration.i18nLookup.name,
    component: i18nlookup,
  },
  {
    path: ViewConfiguration.i18nForm.path,
    name: ViewConfiguration.i18nForm.name,
    component: i18nForm,
  },
  {
    path: ViewConfiguration.bulkUpdate.path,
    name: ViewConfiguration.bulkUpdate.name,
    component: BulkUpdate,
    props(route) {
      return {
        rootType: route.query.rootType,
        fieldIds: route.query.fieldIds.split(','),
        recordIds: route.query.recordIds.split(','),
        listBpdId: route.query.listBpdId,
        bpdId: route.query.bpdId,
      }
    },
  },
  {
    path: ViewConfiguration.listViewVisualisation.path,
    name: ViewConfiguration.listViewVisualisation.name,
    component: ListViewVisualisation,
    props: (route) => ({
      ...route.query,
      measures: compact([].concat(route.query.measures)),
      calculatedMeasures: compact([].concat(route.query.calculatedMeasures)),
      wordCloudColumns: [].concat(route.query.wordCloudColumns),
      calculated: route.query.calculated === 'true' || route.query.calculated === true,
    }),
    children: map(ChartConfigurations, (config) => {
      return {
        path: config.path,
        name: config.name,
        component: config.component,
      }
    }),
  },
  {
    path: ViewConfiguration.locationMap.path,
    name: ViewConfiguration.locationMap.name,
    component: LocationMap,
    props: (route) => ({ ...route.query }),
  },
  {
    path: ViewConfiguration.locationMapDraw.path,
    name: ViewConfiguration.locationMapDraw.name,
    component: LocationMapPolygonDraw,
    props: (route) => ({ ...route.query }),
  },
  {
    path: ViewConfiguration.multiLocationMap.path,
    name: ViewConfiguration.multiLocationMap.name,
    component: MultiLocationMap,
    props: (route) => ({ ...route.query }),
  },
  {
    path: ViewConfiguration.sustainabilityDataEntry.path,
    name: ViewConfiguration.sustainabilityDataEntry.name,
    component: SustainabilityDataEntry,
    props: (route) => ({
      ...route.query,
      excludeCampaignsIds: [].concat(route.query.excludeCampaignsIds),
    }),
  },
  {
    path: ViewConfiguration.walkthroughDesigner.path,
    name: ViewConfiguration.walkthroughDesigner.name,
    component: WalkthroughDesigner,
    props: (route) => ({ ...route.query }),
  },
  {
    path: ViewConfiguration.importsStatus.path,
    name: ViewConfiguration.importsStatus.name,
    component: ImportsStatus,
  },
  // has to be last
  {
    path: ViewConfiguration.e360Container.path,
    component: E360Container,
    props: (route) => ({ path: route.fullPath }),
  },
]

const router = new VueRouter({
  routes,
})

router.beforeEach(async (to, from, next) => {
  // we only want to load translations on initial navigation to a view
  // if (!from.name) {
  if (!from.name && to.matched.length > 0) {
    const matchedViewConfig = find(ViewConfiguration, (viewConfig) => {
      return viewConfig.path === to.matched[0].path
    })
    // if it has no access redirect immediately
    if (matchedViewConfig.featureFlag) {
      const hasAccess = (await MainMenuService.hasAccess(matchedViewConfig.featureFlag)).data
      if (!hasAccess) {
        next({
          path: 'error404.jsp',
        })
      }
    }
    if (matchedViewConfig && matchedViewConfig.i18nNamespace) {
      const translations = (await LabelService.getInitial(matchedViewConfig.i18nNamespace)).data
      forOwn(translations, (value, key) => router.app.$i18n.setLocaleMessage(key, value))
    }
  }
  next()
})

export default router
